import { AppState } from "../root.reducer";

export const isBillingLoadingSelector = (state: AppState) => state.billing.isLoading;
export const isBillingCheckoutLoadingSelector = (state: AppState) => state.billing.isCheckoutLoading;
export const isBillingVatLoadingSelector = (state: AppState) => state.billing.isVatLoading;
export const billingClientTokenSelector = (state: AppState) => state.billing.clientToken;
export const billingDataSelector = (state: AppState) => state.billing.billing;
export const billingIpDetailsSelector = (state: AppState) => state.billing.ipDetails;
export const paypalClientIdSelector = (state: AppState) => state.billing.paypalClientId;